export const brl = (value) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value ?? 0);

export const STATUS_STYLES = {
  "Em Andamento": "border-[#FFB800]/60 text-[#FFB800] bg-[#FFB800]/10",
  Agendado: "border-blue-500/60 text-blue-400 bg-blue-500/10",
  Concluído: "border-emerald-500/60 text-emerald-400 bg-emerald-500/10",
  Aprovado: "border-emerald-500/60 text-emerald-400 bg-emerald-500/10",
  Pendente: "border-[#FFB800]/60 text-[#FFB800] bg-[#FFB800]/10",
  Recusado: "border-red-500/60 text-red-400 bg-red-500/10",
  Novo: "border-[#FFB800]/60 text-[#FFB800] bg-[#FFB800]/10",
  Contatado: "border-blue-500/60 text-blue-400 bg-blue-500/10",
  Convertido: "border-emerald-500/60 text-emerald-400 bg-emerald-500/10",
};

export const StatusBadge = ({ status }) => (
  <span
    data-testid={`status-badge-${status?.toLowerCase().replace(/\s+/g, "-")}`}
    className={`inline-block whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide ${STATUS_STYLES[status] || "border-zinc-600 text-zinc-400"}`}
  >
    {status}
  </span>
);
